
import {
  ElForm,
  ElFormItem,
  ElButton,
  ElInput,
  ElMessageBox,
  ElMessage,
  ElTooltip,
  ElCheckbox,
  ElLoading,
  ElSelect,
  ElOption,
  ElUpload,
} from 'element-plus'
import { ArrowLeft, Plus, Loading } from '@element-plus/icons-vue'
import { defineComponent, reactive, toRefs, ref, watch, computed, onMounted, nextTick } from 'vue'
import api from '@/services'
import { encode } from 'js-base64'
import { getUUID, $t as language } from '@/Tool'
import { ElFormType } from '@/Types/ElementTypes'
import Vuex from '@/store'
import { useRoute, useRouter } from 'vue-router'
import Verify from '../verifition/Verify.vue'
import { countryCode } from './../email-login/countryCode'
import { $t as langs } from '@/Tool'
import { checkNewUser } from '../../CompanyContract/verifition/api'

export default defineComponent({
  name: 'phoneLogin',
  props: {
    authorizationRequired: {
      type: Boolean,
      default: false,
    },
    forceCorpAuth: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['goIndex', 'registration-step-change'],
  components: {
    ElForm,
    ElFormItem,
    ElButton,
    ElInput,
    ElTooltip,
    ElCheckbox,
    ElSelect,
    ElOption,
    ElUpload,
    Verify,
    ArrowLeft,
    Plus,
  },
  setup(props, { emit }) {
    const route = useRoute()
    const validateUserName = (rule: any, value: any, callback: any) => {
      const regex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!value) {
        callback(new Error(language('login.form.phone')))
      } else if (!regex.test(value) && data.formData.areaCode == 'China') {
        //中国大陆
        callback(new Error(langs('phone.login.rule[3]')))
      } else if (!data.isReg) {
        api.Scrm_sys_api.srcmLogin
          .bindingRegisterCodeCheck(
            {
              error: false,
            },
            value,
            true,
          )
          .then((resp) => {
            const { success, data: respData, message } = resp
            if (success) {
              data.hasBinding = respData
              // respData?callback():callback(new Error('请先完成注册或'))
              callback()
            } else {
              callback(new Error(message))
            }
          })
          .catch((errMessage) => {
            callback(new Error(errMessage))
          })
      } else {
        callback()
      }
    }

    api.ConfigServer.getDictByName('小视频').then((res) => {
      if (res.success) {
        data.signupInviteCodeRequired =
          res.data.childOption.find(
            (item: any) => 'signup_invite_code_required' === item.optionName,
          )?.optionValue === 'true'
        data.rules.registerCode[0].required = data.signupInviteCodeRequired
      }
    })

    const verify = ref(null)

    const onShow = (phone) => {
      verify.value.show(phone)
    }
    const data = reactive({
      noLogin: true,
      agreeChecked: false,
      agreeMsgChecked: false,
      token: '',
      formData: {
        username: '',
        password: '',
        verify: '',
        registerCode: '',
        areaCode: 'China',
      },
      registData: {
        corpName: '',
        linkman: '',
      },
      rules: {
        username: [
          {
            required: true,
            message: language('login.form.username'),
            trigger: 'blur',
          },
          {
            validator: validateUserName,
            trigger: 'change',
          },
        ],
        password: [
          {
            required: true,
            message: langs('phone.login.setPassword'),
            trigger: 'blur',
          },
        ],
        verify: [
          {
            required: true,
            message: language('login.form.code'),
            trigger: 'blur',
          },
        ],
        registerCode: [
          {
            required: false,
            message: langs('phone.login.rule[4]'),
            trigger: 'blur',
          },
        ],
      },
      registrules: {
        corpName: [
          {
            required: true,
            message: langs('phone.login.rule[5]'),
            trigger: 'blur',
          },
        ],
        linkman: [
          {
            required: true,
            message: langs('phone.login.rule[6]'),
            trigger: 'blur',
          },
        ],
      },
      forgetRules: {
        username: [
          {
            required: true,
            message: langs('login.form.username'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: langs('phone.login.setPassword'),
            trigger: 'blur',
          },
          {
            pattern: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&.,:;'])[A-Za-z\d$@$!%*#?&.,:;']{8,}$/,
            message: langs('phone.login.rule[7]'),
          },
        ],
        verify: [
          {
            required: true,
            message: langs('login.form.code'),
            trigger: 'blur',
          },
        ],
      },
      loging: false,
      verifySrc: '',
      clickStyle: 'clickStyle',
      buttonStyle: {
        marginBottom: '70px',
      },
      CreatePhone: '',
      isClick: true, //账号登录为false  短信验证码登录为true
      countDown: 0,
      isNotNewUser: false,
      isregist: false,
      registerToken: '',
      loginDisabled: true,
      forgetPswDisabled: false,
      isPhoneBlue: 'icon-username',
      isPasswordBlue: 'icon-password',
      ischeckCodeBlue: 'icon-checkCode',
      isRegisterCodeBlue: 'icon-registerCode',
      isCorpNameBlue: 'icon-corpname',
      hasBinding: true,
      signupInviteCodeRequired: false,
      isReg: false, //注册按钮
      wxQrCode: '',
      wxLoginState: 0,
      wxAccessToken: undefined,
      countryCode: countryCode,
      countryCodeCopy: countryCode,
      lang:
        localStorage.getItem('lang') || (navigator.language.substr(0, 2) !== 'zh' ? 'en' : 'zh'),
      areaCode: 86,
      registrationStep: 1, // 注册步骤：1-手机验证，2-企业认证
      showCertificationDialog: false,
      registrationData: {
        corpName: '',
        businessLicenseFile: null as File | null,
        authorLetterFile: null as File | null,
        businessLicensePreviewUrl: '', // 用于预览显示
        authorLetterPreviewUrl: '', // 用于预览显示
      },
      businessLicenseFileList: [] as any[],
      authorLetterFileList: [] as any[],
      businessLicenseUploading: false,
      authorLetterUploading: false,
      previewDialogVisible: false,
      previewImageUrl: '',
    })
    const ruleForm = ref<string | ElFormType>('ruleForm') // 获取表单组件
    const registruleForm = ref<string | ElFormType>('registruleForm') // 获取表单组件
    const reRuleForm = ref<string | ElFormType>('reRuleForm') // 获取重置密码表单组件
    const certificationFormRef = ref<string | ElFormType>('certificationFormRef') // 获取认证表单组件
    // const isShow = ref(false)
    const is3Part = computed(() => Vuex.state.is3Part)
    const shareId = useRoute()?.query?.shareId

    // 认证相关的验证规则
    const certificationRules: any = {
      corpName: [
        {
          required: true,
          message: langs('certification.form.corpNameRequired'),
          trigger: 'blur',
        },
      ],
    }
    // const certificationRules = computed(() => {
    //   const baseRules: any = {
    //     corpName: [
    //       {
    //         required: true,
    //         message: langs('certification.form.corpNameRequired'),
    //         trigger: 'blur',
    //       },
    //     ],
    //     businessLicenseUrl: [
    //       {
    //         required: true,
    //         message: langs('certification.form.businessLicenseRequired'),
    //         trigger: 'change',
    //       },
    //     ],
    //   }

    //   if (data.authorizationRequired) {
    //     baseRules.authorLetterUrl = [
    //       {
    //         required: true,
    //         message: langs('certification.form.authorLetterRequired'),
    //         trigger: 'change',
    //       },
    //     ]
    //   }

    //   return baseRules
    // })
    onMounted(() => {
      const ua = navigator.userAgent.toLowerCase()
      if (!ua.includes('chrome')) {
        const hasShowTips = sessionStorage.getItem('showNavigatorTips')
        if (!hasShowTips) {
          ElMessageBox.alert(langs('phone.login.rule[8]'), langs('phone.login.tips'), {
            confirmButtonText: langs('phone.iCan'),
            showClose: false,
            center: true,
          }).then(() => {
            sessionStorage.setItem('showNavigatorTips', 'true')
          })
        }
      }

      const path = useRoute().fullPath
      if (path.includes('school')) {
        data.isClick = false
        localStorage.setItem('isSchool', 'school')
      } else {
        data.isClick = true
        localStorage.removeItem('isSchool')
      }
      if (path.includes('huaweiyun')) {
        sessionStorage.setItem('isHuaweiyun', 'huawei')
        // const searchParams = new URLSearchParams(window.location.search)
        // const code = searchParams.get('code')
        const tenant = useRoute()?.query?.tenant
        const code = useRoute()?.query?.code + ''
        if (code && tenant) {
          // 已经拿到三方登录code，
          const loadingInstance = ElLoading.service({
            text: langs('phone.login.loading'),
          })
          api.IsvApi.isvLogin(
            {
              error: false,
            },
            code,
            tenant.toString(),
          ).then((resp) => {
            loadingInstance.close()
            emit('goIndex', { loginInfo: resp.object, shareId: shareId })
          })
        }
      }
      if (path.includes('wechat_redirect')) {
        // 微信登录
        const code = useRoute()?.query?.code
        if (code) {
          handleWechatLogin(code)
        }
      }
      getAreaCode(data.formData.areaCode)
    })
    //根据token免登录
    const router = useRouter()
    // const route = useRoute()
    // onMounted(() => {
    //   console.log('这是中文版本')
    //   // istoken()
    // })
    //监听状态切换
    watch(
      () => data.isClick,
      (oldVlaue: any, newValue: any) => {
        clearInput()
        const elform1 = ruleForm.value as ElFormType
        elform1.resetFields()
      },
    )
    //提交新密码
    const submitNewPsw = () => {
      data.loging = true
      const elform = reRuleForm.value as ElFormType
      elform.validate((valid: boolean) => {
        if (!valid) {
          data.loging = false
          return null
        }
        setPswHandle()
      })
    }
    async function setPswHandle() {
      try {
        const res: any = await resetPsw()
        if (res) {
          ElMessage({
            message: res.message ?? langs('phone.reset.password'),
            type: 'success',
          })
        }
        clearInput()
        getPictureVerify()
        data.loginDisabled = true
        data.forgetPswDisabled = false
        data.loging = false
      } catch (e) {
        data.loging = false
        ElMessage({
          message: (e as string) ?? langs('phone.account.nothing'),
          type: 'warning',
        })
        clearInput()
      }
    }
    const resetPsw = async () => {
      let result = []
      try {
        result = await api.Scrm_sys_api.srcmLogin.resetPasswd({
          error: false,
          success: false,
          data: {
            code: data.formData.verify,
            mobile: data.formData.username,
            passwd: encode(data.formData.password),
          },
        })
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }

    //返回注册类型选择
    const createNewcorpPage = () => {
      // clearInput()
      data.loginDisabled = false
      data.forgetPswDisabled = false
      data.isregist = false
      data.isNotNewUser = true
    }
    //返回注册类型选择
    const goBackReg = () => {
      // clearInput()
      data.loginDisabled = false
      data.forgetPswDisabled = false
      data.isNotNewUser = false
      data.isregist = true
    }
    //忘记密码返回按钮
    const goBack = () => {
      clearInput()
      data.loginDisabled = true
      data.forgetPswDisabled = false
    }
    //忘记密码
    const setNewPsw = () => {
      clearInput()
      data.loginDisabled = false
      data.forgetPswDisabled = true
      // console.log(data.loginDisabled)
    }

    let sessionId: string // 登陆唯一id
    // 获取图片验证码
    const getPictureVerify = async () => {
      sessionId = getUUID()
      data.verifySrc = api.Scrm_sys_api.srcmLogin.pictureVerify(sessionId)
    }

    getPictureVerify()

    //发送验证码
    const sendMsgFn = () => {
      if (!data.agreeMsgChecked && ![86, 852, 853, 886].includes(data.areaCode)) {
        ElMessage({
          message: language('login.agreeMsgError'),
          type: 'warning',
        })
        return
      }
      //正则校验手机号
      const username = data.formData.username
      const regex = /^(?:(?:\+|00)86)?1\d{10}$/
      if (!username || (!regex.test(username) && data.formData.areaCode == 'China')) {
        ElMessage({
          message: langs('phone.login.rule[3]'),
          type: 'error',
        })
        // isShow.value = false
        return
      }

      checkNewUser({ mobile: username }).then((res: any) => {
        if (res.success) {
          if (data.isReg) {
            if (!res.data) {
              data.CreatePhone = username
              // isShow.value = true
              onShow(username)
              // setTimeBox()
            } else {
              ElMessage({
                message: langs('phone.login.rule[10]'),
                type: 'error',
              })
            }
          } else {
            if (res.data) {
              data.CreatePhone = username
              // isShow.value = true
              onShow(username)
              // setTimeBox()
            } else {
              ElMessage({
                message: langs('phone.login.rule[9]'),
                type: 'error',
              })
            }
          }
        }
      })
    }

    //注册企业
    const createNewcorp = () => {
      data.loging = true
      const elform1 = registruleForm.value as ElFormType
      elform1.validate((valid: boolean) => {
        if (!valid) {
          data.loging = false
          return null
        }
        createCorp()
      })
    }

    //创建游客
    const createTourist = () => {
      // const elform2 = registruleForm.value as ElFormType
      // elform2.resetFields()
      ;(data.registData.corpName = ''), (data.registData.linkman = ''), createCorp()
    }

    async function createCorp() {
      try {
        const res = await createAndLogin()
        const { token, userInfo } = res.object ?? {}
        //将登录信息传递给父组件
        emit('goIndex', { loginInfo: res.object, shareId: shareId, noLogin: data.noLogin })
        data.loging = false
      } catch (e) {
        data.loging = false
      }
    }
    //注册企业
    const createAndLogin = async () => {
      try {
        const result = await api.Biz_api.srcmLogin.Login(
          {
            error: true,
            data: {
              corpName: data.registData.corpName,
              linkman: data.registData.linkman,
              phone: data.CreatePhone,
              registerToken: data.registerToken,
              smsCode: data.formData.verify,
              loginType: 2,
              source: 3, //	来源 1.app 2.pc-duix官网 3.pc-口播平台
            },
          },
          data.CreatePhone,
        )
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }
    const onSuccess = (params) => {
      if (params) {
        data.countDown = 60
        const timer = setInterval(() => {
          data.countDown--
          if (data.countDown === 0) {
            clearInterval(timer)
          }
        }, 1000)
        ElMessage({
          message: langs('phone.login.tips[1]'),
          type: 'success',
        })
      } else {
        ElMessage({
          message: langs('phone.login.tips[2]'),
          type: 'warning',
        })
      }
    }

    // 登陆函数
    const login = async () => {
      let result: any
      const localBrowserUniqueCode = localStorage.getItem('browserUniqueCode')
      const browserUniqueCode = localBrowserUniqueCode || getUUID()
      if (!localBrowserUniqueCode) {
        localStorage.setItem('browserUniqueCode', browserUniqueCode)
      }
      let params = {
        areaCode: data.areaCode,
        loginType: 2,
        source: 3,
        phone: data.formData.username,
        smsCode: data.formData.verify,
        registerCode: data.formData.registerCode,
        browserUniqueCode,
        wxAccessToken: data.wxLoginState == 2 ? data.wxAccessToken : undefined,
        isOpenLog: false, //记录日志
      }
      try {
        if (data.isReg) {
          result = await api.Biz_api.srcmLogin.personalRegister({
            data: params,
          })
        } else {
          result = await api.Biz_api.srcmLogin.Login(
            {
              error: true,
              success: false,
              data: data.isClick
                ? {
                    loginType: 2,
                    areaCode: data.areaCode,
                    username: data.formData.username,
                    password: encode(data.formData.password),
                    phone: data.formData.username,
                    smsCode: data.formData.verify,
                    browserUniqueCode, // 浏览器标识
                    wxAccessToken: data.wxLoginState == 2 ? data.wxAccessToken : undefined,
                    isOpenLog: false, //记录日志
                  }
                : {
                    // ...data.formData,
                    username: data.formData.username,
                    verify: data.formData.verify,
                    registerCode: data.formData.registerCode,
                    sessionId,
                    loginType: 1,
                    password: encode(data.formData.password),
                    browserUniqueCode,
                    wxAccessToken: data.wxLoginState == 2 ? data.wxAccessToken : undefined,
                    isOpenLog: false, //记录日志
                  },
            },
            sessionId,
          )
          // if (data.isClick) {
          //   result = await api.Biz_api.srcmLogin.LoginV2(
          //     {
          //       error: true,
          //       data: params,
          //     },
          //     sessionId,
          //   )
          // } else {
          //   result = await api.Biz_api.srcmLogin.Login(
          //     {
          //       data: {
          //         ...data.formData,
          //         sessionId,
          //         loginType: 1,
          //         password: encode(data.formData.password),
          //         browserUniqueCode,
          //         wxAccessToken: data.wxLoginState == 2 ? data.wxAccessToken : undefined,
          //       },
          //     },
          //     sessionId,
          //   )
          // }
        }
        return Promise.resolve(result)
      } catch (e) {
        return Promise.reject(e)
      }
    }
    // 华为云登录
    const handleHuaweiyunLogin = () => {
      // const redirect_uri = encodeURI('http://localhost:8000/vshow-main/#/huaweiyun/login');
      const appid = 'c9109febcdb94a2bb14dce6afb4ef988'
      const url = `https://macroverse.huaweicloud.com/unified-login/#/portal-login?ind=UNOP&appId=${appid}`
      location.href = url
    }
    const handleToggleReg = () => {
      data.isReg = !data.isReg
      if (!data.isReg) {
        data.hasBinding = true
      } else {
        resetRegistrationStep()
      }
      clearInput()
      const elform1 = ruleForm.value as ElFormType
      elform1.resetFields()
    }

    // 登陆验证
    const submitForm = () => {
      // 如果是注册第二步，使用认证表单验证
      if (data.isReg && data.registrationStep === 2) {
        if (!certificationFormRef.value) {
          return
        }
        const certificationForm = certificationFormRef.value as ElFormType
        certificationForm.validate((valid: boolean) => {
          if (!valid) return
          handleCertificationSuccess(data.registrationData)
        })
        return
      }

      // 第一步表单验证
      data.loging = true
      const elform = ruleForm.value as ElFormType
      elform.validate((valid: boolean) => {
        if (!valid) {
          data.loging = false
          return null
        }
        if (!data.agreeMsgChecked && ![86, 852, 853, 886].includes(data.areaCode)) {
          ElMessage({
            message: language('login.agreeMsgError'),
            type: 'warning',
          })
          data.loging = false
          return null
        }
        if (!data.agreeChecked) {
          data.loging = false
          ElMessage({
            message: language('login.agreementError'),
            type: 'warning',
          })
          return null
        }

        // 如果是注册第一步，验证通过后进入第二步
        if (data.isReg && data.registrationStep === 1) {
          data.registrationStep = 2
          data.loging = false
          return
        }

        loginHandle()
      })
    }

    //清空输入框
    const clearInput = () => {
      ;(data.formData.username = ''),
        (data.formData.password = ''),
        (data.formData.verify = ''),
        (data.isPhoneBlue = 'icon-username'),
        (data.isPasswordBlue = 'icon-password'),
        (data.ischeckCodeBlue = 'icon-checkCode'),
        (data.isRegisterCodeBlue = 'icon-registerCode')
    }
    const handleErrorMessage = (message: string) => {
      /*
       * INVALID_REGISTER_CODE("1000053", "无效邀请码"),
       * REGISTER_CODE_IS_EMPTY("1000054", "请输入邀请码"),
       * BIND_REGISTER_CODE_ERROR("1000055", "邀请码失败"),
       * BIND_REGISTER_CODE_ERROR("用户不存着", "用户不存在, 请先完成注册"),
       */
      switch (message) {
        case '1000053':
          return langs('phone.login.tips[3]')
        case '1000054':
          return langs('phone.login.rule[4]')
        case '1000055':
          return langs('phone.code.error')
        case '用户不存在':
          return langs('phone.user.error')
        default:
          return message
      }
    }
    //vuex状态存储
    async function loginHandle() {
      try {
        const res: any = await login()
        const token = res.data?.token ? res.data.token : res.object.token ? res.object.token : null
        const userInfo = res.data?.userInfo
          ? res.data?.userInfo
          : res?.object?.userInfo
          ? res?.object?.userInfo
          : null

        //根据uesrInfo来判断是否是新用户，如果userInfo=null则该用户为新用户，否则该用户存在。
        if (token && !userInfo) {
          data.registerToken = token
          data.loginDisabled = false
          data.isregist = true
        } else {
          //用户存在
          const Obj = {
            token,
            userInfo,
          }

          // 根据userInfo中的newUser字段0-新用户，1-老用户
          let newUser = userInfo?.newUser

          if (newUser === null) {
            // 获取配置项时间
            const newRegisterTimeRes: any = await api.ConfigServer.getDictByName('新用户判断时间')
            const newRegisterTime = newRegisterTimeRes.data?.childOption?.find(
              (item: any) => item.optionName === 'newRegisterTime',
            )?.optionValue
            if (newRegisterTime) {
              // 根据userInfo中的createTime和newRegisterTime时间对比，如果在newRegisterTime时间之前，0是新用户 1是老用户；如果在newRegisterTime时间之后，则为老用户
              newUser =
                new Date(userInfo?.createTime).getTime() < new Date(newRegisterTime).getTime()
                  ? 1
                  : 0
            }
          }

          // 根据用户信息中editionList字段来判断是否有硅语权限，在配置时间之后的新用户包含0和1才能够登录成功，否则提示没有权限
          // 0-所有 1-硅语元宇宙 2-虚拟直播 3-DUIX 4-换脸直播 5-数字人直播视频版 6-数字人直播APP本地生活版
          if (newUser === 0) {
            const editionList = userInfo?.editionList || []
            if (!editionList.includes(0) && !editionList.includes(1)) {
              ElMessage({
                message: langs('phone.login.notAllowedTip'),
                type: 'warning',
              })
              data.loging = false
              return
            }
          }

          const isJump = newUser ?? 1

          if (isJump === 1) {
            const isTestOrigin = location.origin.includes('prevshow')
            const isLocalOrigin = location.origin.includes('localhost')
            const jumpOrigin =
              isTestOrigin || isLocalOrigin
                ? 'https://prevshow.wonderuyi.com'
                : 'https://meta.wonderuyi.com'
            const redirectUrl = `${jumpOrigin}/guiyu-main/?token=${token}#/guiyu/workBench/newBench`
            window.location.href = redirectUrl
            return
          }

          //将登录信息传递给父组件
          emit('goIndex', { loginInfo: Obj, shareId: shareId, noLogin: data.noLogin })
          getPictureVerify()
        }
        api.Biz_api.srcmLogin.UserOperationLog({
          data: {
            page: data.isReg ? '用户注册' : '用户登录',
            eventName: 'agreement_protocol',
            mobile: data.formData.username,
            eventDesc: '用户勾选同意《用户协议》、《隐私政策》、《用户管理规则公约及数据处理条款》',
            source: 'guiyu_web',
          },
        })
        clearInput()
        data.loging = false
      } catch (res: any) {
        if (res === '验证码错误') {
          getPictureVerify()
          data.formData.verify = ''
          data.loging = false
          return
        }
        getPictureVerify()
        if (data.isClick) {
          data.formData.verify = ''
        }
        data.loging = false
      }
    }
    // 跳转协议/隐私
    const handleGoAgreement = (type: string, e: Event) => {
      e.preventDefault()
      const url = `${location.origin}/vshow-main/${type}`
      window.open(url, '_blank')
    }

    const onInputFocus = (e: any, type: string) => {
      type === 'phone'
        ? (data.isPhoneBlue = 'icon-username_blue')
        : (data.isPhoneBlue = 'icon-username')
      type === 'password'
        ? (data.isPasswordBlue = 'icon-password_blue')
        : (data.isPasswordBlue = 'icon-password')
      type === 'checkCode'
        ? (data.ischeckCodeBlue = 'icon-checkCode_blue')
        : (data.ischeckCodeBlue = 'icon-checkCode')
      type === 'registerCode'
        ? (data.isRegisterCodeBlue = 'icon-registerCode_blue')
        : (data.isRegisterCodeBlue = 'icon-registerCode')
      type === 'corpName'
        ? (data.isCorpNameBlue = 'icon-corpname_blue')
        : (data.isCorpNameBlue = 'icon-corpname')
    }

    const wechatLogin = () => {
      if (!data.agreeChecked) {
        ElMessage({
          message: langs('phone.login.tips[4]'),
          type: 'warning',
        })
        return
      }
      const redirectUri = location.href.split('?')[0]
      location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wx541487ca137d6a91&redirect_uri=${encodeURIComponent(
        redirectUri,
      )}&response_type=code&scope=snsapi_login&state=wechat_redirect`
      // api.Scrm_sys_api.srcmLogin.getWxQrCode(1).then((resp) => {
      //   if (resp.success) {
      //     data.wxQrCode = resp.data
      //   }
      // })
      // data.loginDisabled = false
    }

    const handleWechatLogin = (code) => {
      const loadingInstance = ElLoading.service({
        text: langs('phone.login.loading'),
      })
      api.Scrm_sys_api.srcmLogin
        .wxLogin(code)
        .then((resp) => {
          if (resp.success && resp.data) {
            if (!resp?.data?.token) {
              data.wxLoginState = 2
              data.loginDisabled = true
              data.wxAccessToken = resp.data.wxAccessToken
            } else {
              emit('goIndex', { loginInfo: resp.data })
            }
          }
        })
        .catch(() => {
          data.wxLoginState = 0
          data.loginDisabled = true
        })
        .finally(() => loadingInstance.close())
    }
    const getAreaCode = (en: string) => {
      const area = countryCode.filter((item) => item.en == en)
      data.areaCode = area?.[0]?.code
    }
    const focusAreaCode = () => {
      data.countryCode = data.countryCodeCopy
    }
    const changeAreaCode = (code: string) => {
      getAreaCode(code)
    }

    const filterAreaCode = (value) => {
      const obj = {
        zh: 'cn',
        en: 'en',
      }
      if (value) {
        data.countryCode = data.countryCodeCopy.filter((item) => {
          if (
            !!~item[obj[data.lang]].indexOf(value) ||
            !!~item[obj[data.lang]].toUpperCase().indexOf(value.toUpperCase())
          ) {
            return true
          }
        })
      } else {
        data.countryCode = data.countryCodeCopy
      }
    }

    // 企业认证成功处理
    const handleCertificationSuccess = async (certificationData) => {
      data.registrationData = certificationData
      data.showCertificationDialog = false

      // 调用注册接口，包含企业认证信息
      try {
        data.loging = true
        const localBrowserUniqueCode = localStorage.getItem('browserUniqueCode')
        const browserUniqueCode = localBrowserUniqueCode || getUUID()
        if (!localBrowserUniqueCode) {
          localStorage.setItem('browserUniqueCode', browserUniqueCode)
        }
        if (!data.registrationData.corpName) {
          ElMessage.error(langs('certification.form.corpNameRequired'))
          data.loging = false
          return
        }
        if (!data.registrationData.businessLicenseFile) {
          ElMessage.error(langs('certification.form.businessLicenseRequired'))
          data.loging = false
          return
        }
        if (props.authorizationRequired && !data.registrationData.authorLetterFile) {
          ElMessage.error(langs('certification.form.authorLetterRequired'))
          data.loging = false
          return
        }

        // 使用 FormData 提交
        const formData = new FormData()
        formData.append('areaCode', data.areaCode.toString())
        formData.append('loginType', '2')
        formData.append('source', '3')
        formData.append('phone', data.formData.username)
        formData.append('smsCode', data.formData.verify)
        formData.append('registerCode', data.formData.registerCode || '')
        formData.append('browserUniqueCode', browserUniqueCode)
        formData.append('corpName', data.registrationData.corpName)
        formData.append('businessLicenseFile', data.registrationData.businessLicenseFile)
        if (data.registrationData.authorLetterFile) {
          formData.append('authorLetterFile', data.registrationData.authorLetterFile)
        }
        formData.append('corpType', '1')
        formData.append('corpAuditStatus', '2')
        formData.append('isOpenLog', 'false')

        const result = await api.Biz_api.srcmLogin.personalRegisterV2({
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        // 注册成功，传递登录信息给父组件
        emit('goIndex', { loginInfo: result.object, shareId: shareId, noLogin: data.noLogin })
        setTimeout(() => {
          api.Biz_api.srcmLogin.UserOperationLog({
            data: {
              page: data.isReg ? '用户注册' : '用户登录',
              eventName: 'agreement_protocol',
              mobile: data.formData.username,
              eventDesc:
                '用户勾选同意《用户协议》、《隐私政策》、《用户管理规则公约及数据处理条款》',
              source: 'guiyu_web',
            },
          })
        }, 10)
        data.loging = false
      } catch (error) {
        console.error('注册失败:', error)
        data.loging = false
      }
    }

    // 企业认证取消处理
    const handleCertificationCancel = () => {
      data.showCertificationDialog = false
      // 可以选择回到第一步或保持在第二步
    }

    // 重置注册步骤
    const resetRegistrationStep = () => {
      data.registrationStep = 1
      data.registrationData = {
        corpName: '',
        businessLicenseFile: null,
        authorLetterFile: null,
        businessLicensePreviewUrl: '',
        authorLetterPreviewUrl: '',
      }
    }

    // 返回第一步
    const goBackToStep1 = () => {
      data.registrationStep = 1
    }

    // 语言切换
    const langChange = (lang: string) => {
      localStorage.setItem('lang', lang)
      data.lang = lang
      location.reload()
    }

    // 文件上传相关方法
    const beforeUpload = (file: File) => {
      const isValidSize = file.size / 1024 / 1024 < 10
      if (!isValidSize) {
        ElMessage.error(langs('certification.upload.sizeLimit'))
        return false
      }
      return true
    }

    const handleExceed = () => {
      ElMessage.warning(langs('certification.upload.limitExceeded'))
    }

    // 营业执照上传处理 - 本地保存文件
    const handleBusinessLicenseUpload = (options: any) => {
      try {
        const { file } = options
        const rawFile = file.raw || file

        if (!rawFile) {
          ElMessage.error(langs('certification.upload.imageTypeError'))
          data.businessLicenseUploading = false
          nextTick(() => {
            if (businessLicenseUpload.value) {
              businessLicenseUpload.value.clearFiles()
            }
          })
          return false
        }

        // 生成预览URL
        const previewUrl = URL.createObjectURL(rawFile)

        // 保存文件到本地
        data.registrationData.businessLicenseFile = rawFile
        data.registrationData.businessLicensePreviewUrl = previewUrl
        data.businessLicenseFileList = [{ name: rawFile.name, url: previewUrl }]
        data.businessLicenseUploading = false
        // 阻止默认上传行为
        return false
      } catch (error: any) {
        ElMessage.error(error || langs('certification.upload.imageTypeError'))
        // 出错时，清空相关状态，确保可以重新上传
        data.registrationData.businessLicenseFile = null
        data.registrationData.businessLicensePreviewUrl = ''
        data.businessLicenseFileList = []
        data.businessLicenseUploading = false
        nextTick(() => {
          if (businessLicenseUpload.value) {
            businessLicenseUpload.value.clearFiles()
          }
        })
        return false
      }
    }

    // 删除函数
    const handleBusinessLicenseRemove = () => {
      // 释放预览URL
      if (data.registrationData.businessLicensePreviewUrl) {
        URL.revokeObjectURL(data.registrationData.businessLicensePreviewUrl)
      }
      data.registrationData.businessLicenseFile = null
      data.registrationData.businessLicensePreviewUrl = ''
      data.businessLicenseFileList = []
      data.businessLicenseUploading = false
      nextTick(() => {
        if (businessLicenseUpload.value) businessLicenseUpload.value.clearFiles()
      })
    }

    // 授权书上传处理 - 本地保存文件
    const handleAuthorLetterUpload = (options: any) => {
      try {
        const { file } = options
        const rawFile = file.raw || file

        if (!rawFile) {
          ElMessage.error(langs('certification.upload.fileTypeError'))
          data.authorLetterUploading = false
          nextTick(() => {
            if (authorLetterUpload.value) {
              authorLetterUpload.value.clearFiles()
            }
          })
          return false
        }

        // 保存文件到本地
        data.registrationData.authorLetterFile = rawFile
        data.authorLetterFileList = [{ name: rawFile.name }]
        data.authorLetterUploading = false
        // 阻止默认上传行为
        return false
      } catch (error: any) {
        ElMessage.error(error || langs('certification.upload.fileTypeError'))
        // 出错时，清空相关状态，确保可以重新上传
        data.registrationData.authorLetterFile = null
        data.authorLetterFileList = []
        data.authorLetterUploading = false
        nextTick(() => {
          if (authorLetterUpload.value) {
            authorLetterUpload.value.clearFiles()
          }
        })
        return false
      }
    }

    // 删除函数
    const handleAuthorLetterRemove = () => {
      data.registrationData.authorLetterFile = null
      data.authorLetterFileList = []
      data.authorLetterUploading = false
      nextTick(() => {
        if (authorLetterUpload.value) authorLetterUpload.value.clearFiles()
      })
    }

    // 获取当前语言
    const getCurrentLang = () => {
      if (typeof window !== 'undefined' && window.localStorage) {
        return (window.localStorage.getItem('lang') || 'zh').toLowerCase()
      }
      return 'zh'
    }

    // 获取授权书示例预览图片URL
    const getAuthorLetterPreviewUrl = () => {
      const currentLang = getCurrentLang()
      return currentLang === 'zh'
        ? require('@/assets/images/certification-origin2.png')
        : require('@/assets/images/certification-origin3.png')
    }

    // 预览示例图片
    const handlePreviewExample = (imageUrl: string) => {
      data.previewImageUrl = imageUrl
      data.previewDialogVisible = true
    }

    // 监听 registrationStep 变化并通知父组件
    watch(
      () => data.registrationStep,
      (newStep, oldStep) => {
        emit('registration-step-change', newStep)
        // 当进入第二步时，重新生成预览URL（确保预览URL有效）
        if (newStep === 2 && oldStep === 1) {
          // 重新生成营业执照预览URL（如果文件存在）
          if (data.registrationData.businessLicenseFile) {
            // 释放旧的预览URL（如果存在）
            if (data.registrationData.businessLicensePreviewUrl) {
              URL.revokeObjectURL(data.registrationData.businessLicensePreviewUrl)
            }
            // 重新生成预览URL
            data.registrationData.businessLicensePreviewUrl = URL.createObjectURL(
              data.registrationData.businessLicenseFile,
            )
            data.businessLicenseFileList = [
              {
                name: data.registrationData.businessLicenseFile.name,
                url: data.registrationData.businessLicensePreviewUrl,
              },
            ]
          }
          // 确保授权书文件列表正确（如果文件存在）
          if (data.registrationData.authorLetterFile && data.authorLetterFileList.length === 0) {
            data.authorLetterFileList = [{ name: data.registrationData.authorLetterFile.name }]
          }
        }
      },
    )

    // 预览功能
    const handlePreview = (url: string) => {
      if (isImage(url)) {
        // 对于图片，使用预览弹窗
        data.previewImageUrl = url
        data.previewDialogVisible = true
      } else {
        // 对于文档，在新窗口打开
        window.open(url, '_blank')
      }
    }

    // 判断是否为图片
    const isImage = (url: string) => {
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url)
    }

    // 获取文件名
    const getFileName = (url: string) => {
      const parts = url.split('/')
      return parts[parts.length - 1] || '文件'
    }

    // 下载模板
    const handleDownloadTemplate = () => {
      const currentLang = data.lang || 'zh'
      const downloadUrl =
        currentLang === 'zh'
          ? 'https://digital-public.obs.cn-east-3.myhuaweicloud.com/guiyu-web/assets/%E6%8E%88%E6%9D%83%E4%B9%A6.docx'
          : 'https://digital-public.obs.cn-east-3.myhuaweicloud.com/guiyu-web/assets/Authorization.docx'

      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = currentLang === 'zh' ? '授权书模板.docx' : 'Authorization.docx'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    // 获取示例图片URL
    const getExampleImageUrl = () => {
      const currentLang = data.lang || 'zh'
      if (currentLang === 'zh') {
        return require('@/assets/images/certification-demo2.png')
      } else {
        // 暂时使用中文图片，等英文图片准备好后再修改
        return require('@/assets/images/certification-demo2-en.png')
      }
    }

    // 营业执照上传相关方法
    const handleBusinessLicenseExceed = (files: any) => {
      data.businessLicenseFileList = []
      const file = files[0]
      data.businessLicenseFileList = [file]
    }

    const beforeBusinessLicenseUpload = (file: any) => {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5

      if (!isImage) {
        ElMessage.error(langs('certification.upload.imageTypeError'))
        return false
      }
      if (!isLt5M) {
        ElMessage.error(langs('certification.upload.imageSizeLimit'))
        return false
      }
      data.businessLicenseUploading = true
      return true
    }

    // 授权书上传相关方法
    const handleAuthorLetterExceed = (files: any) => {
      data.authorLetterFileList = []
      const file = files[0]
      data.authorLetterFileList = [file]
    }

    const beforeAuthorLetterUpload = (file: any) => {
      const isValidType =
        file.type === 'application/msword' ||
        file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.type === 'application/pdf'
      const isLt10M = file.size / 1024 / 1024 <= 10

      if (!isValidType) {
        ElMessage.error(langs('certification.upload.fileTypeError'))
        return false
      }
      if (!isLt10M) {
        ElMessage.error(langs('certification.upload.fileSizeLimit'))
        return false
      }
      data.authorLetterUploading = true
      return true
    }
    const businessLicenseUpload = ref()
    const authorLetterUpload = ref()
    return {
      ...toRefs(data),
      ruleForm,
      registruleForm,
      is3Part,
      submitForm,
      getPictureVerify,
      sendMsgFn,
      createNewcorp,
      createTourist,
      setNewPsw,
      goBack,
      submitNewPsw,
      reRuleForm,
      onInputFocus,
      goBackReg,
      createNewcorpPage,
      handleGoAgreement,
      handleErrorMessage,
      handleHuaweiyunLogin,
      handleToggleReg,
      onShow,
      verify,
      onSuccess,
      wechatLogin,
      handleWechatLogin,
      filterAreaCode,
      focusAreaCode,
      language,
      langs,
      // lang 已经在 ...toRefs(data) 中，是字符串类型
      getAreaCode,
      changeAreaCode,
      handleCertificationSuccess,
      handleCertificationCancel,
      resetRegistrationStep,
      goBackToStep1,
      langChange,
      certificationFormRef,
      certificationRules,
      beforeUpload,
      handleExceed,
      handleBusinessLicenseUpload,
      handleBusinessLicenseRemove,
      handleAuthorLetterUpload,
      handleAuthorLetterRemove,
      handlePreview,
      isImage,
      getFileName,
      handleDownloadTemplate,
      getExampleImageUrl,
      handleBusinessLicenseExceed,
      beforeBusinessLicenseUpload,
      handleAuthorLetterExceed,
      beforeAuthorLetterUpload,
      handlePreviewExample,
      getAuthorLetterPreviewUrl,
      businessLicenseUpload,
      authorLetterUpload,
    }
  },
})
